<template>
	<router-link :to="link" class="company">
		<img
            :src="rowData.country.flag || '//placehold.it/24x16'"
            :alt="rowData.country.name"
            class="flag"
            v-tippy="rowData.country.name"
        />
		<span :class="{ 'name': true, 'not-read': !rowData.read }">
            {{ formattedTitle }}
        </span>
		<span v-if="rowData.urgent" class="pill pill--urgent">Urgent</span>
	</router-link>
</template>

<script>
	export default {
		name: 'ColumnCompany',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		computed: {
            formattedTitle() {
                if(this.rowData.projectName === this.rowData.companyName)
                    return this.rowData.projectName;

                if(!this.rowData.projectName)
                    return this.rowData.companyName;

                return `${this.rowData.projectName} (${this.rowData.companyName})`;
            },
			link() {
				if(this.rowData.status === 2) {
					return { name: 'view-opportunity', params: { opportunity_id: this.rowData.id }}
				} else {
					return { name: 'opportunity-preview', params: { opportunity_id: this.rowData.id }}
				}
			}
		}
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>

<style lang="scss" scoped>
	@import "~reflex-grid/scss/includes/variables";
	@import "~reflex-grid/scss/includes/mixins";
	@import "~@/theme/_variables.scss";

	.company {
		@include display-flex;
		@include align-items(center);
	}

	.flag {
		margin-right: 1.5rem;
		max-width: 2.4rem;
		height: auto;
		@include flex(0, 0, auto);
	}

	.name {
		margin-right: 1.5rem;
		&.not-read{
			font-weight: bold;
		}
	}
</style>
